export type Density = 'compact' | 'standard' | 'comfortable';

export interface GridView {
  order: string[];
  hidden: string[];
  widths: Record<string, number>;
  density: Density;
}

export const DENSITY_PADDING: Record<Density, number> = {
  compact: 3,
  standard: 7,
  comfortable: 12,
};

export function defaultView(keys: string[]): GridView {
  return { order: [...keys], hidden: [], widths: {}, density: 'standard' };
}

/** Reconcile a persisted view against the current column set (add new, drop gone). */
export function reconcileView(saved: Partial<GridView> | null, keys: string[]): GridView {
  const base = defaultView(keys);
  if (!saved) return base;
  const known = new Set(keys);
  const order = (saved.order ?? []).filter((k) => known.has(k));
  for (const k of keys) if (!order.includes(k)) order.push(k);
  const hidden = (saved.hidden ?? []).filter((k) => known.has(k));
  const widths: Record<string, number> = {};
  for (const [k, w] of Object.entries(saved.widths ?? {})) if (known.has(k)) widths[k] = w;
  return { order, hidden, widths, density: saved.density ?? base.density };
}
